import {
  DISTRIBUTOR_DETAIL,
  DISTRIBUTOR_LIST,
  DISTRIBUTOR_ORDER_DETAIL,
  FETCH_DISTRIBUTOR_DISTRICTS,
  ENABLE_DISABLE_DISTRIBUTOR,
  LINK_DISTRIBUTOR,
  LINK_DISTRIBUTOR_LIST,
  DISTRIBUTOR_DISTRICT_EDIT,
  SEND_MAIL,
  MANUFACTURER_DROPDOWN,
  DISTRIBUTOR_DIVISION_LIST,
  CREATE_DISTRIBUTOR,
  DISTRIBUTOR_ONBOARDING_LIST,
  
} from "./types";

export const distributorList = (data, onSuccess, onError) => {
  return {
    type: DISTRIBUTOR_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const distributorOnboardingList = (data, onSuccess, onError) => {
  return {
    type: DISTRIBUTOR_ONBOARDING_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const distributorDetail = (id, onSuccess, onError) => {
  return {
    type: DISTRIBUTOR_DETAIL,
    id,
    onSuccess,
    onError,
  };
};

export const orderDetail = (data, onSuccess, onError) => {
  return {
    type: DISTRIBUTOR_ORDER_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const enableDisableDistributor = (id, onSuccess, onError) => {
  return {
    type: ENABLE_DISABLE_DISTRIBUTOR,
    id,
    onSuccess,
    onError,
  };
};

export const linkDistributor = (data, onSuccess, onError) => {
  return {
    type: LINK_DISTRIBUTOR,
    data,
    onSuccess,
    onError,
  };
};
export const linkDistributorList = (onSuccess, onError) => {
  return {
    type: LINK_DISTRIBUTOR_LIST,
    onSuccess,
    onError,
  };
};
export const fetchDistributorDistricts = (id, onSuccess, onError) => {
  return {
    type: FETCH_DISTRIBUTOR_DISTRICTS,
    id,
    onSuccess,
    onError,
  };
};

export const editDistributorDistricts = (data, onSuccess, onError) => {
  return {
    type: DISTRIBUTOR_DISTRICT_EDIT,
    data,
    onSuccess,
    onError,
  };
};
export const sendMail = (data, onSuccess, onError) => {
  return {
    type: SEND_MAIL,
    data,
    onSuccess,
    onError,
  };
};
export const fetchDivisionList = (onSuccess, onError) => {
  return {
    type: DISTRIBUTOR_DIVISION_LIST,
    onSuccess,
    onError,
  };
};
export const createDistributor = (data, onSuccess, onError) => {
  return {
    type: CREATE_DISTRIBUTOR,
    data,
    onSuccess,
    onError,
  };
};